import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

export class CrystalClearFrontUrlMapping extends AsbCCUrl {
  // MAPPING
  static readonly MAPPING: PageDescription = {
    label: 'page_title.mapping.title',
    roles: CCRoles.ROLES_MAPPING_READ,
    icon: 'fa fa-arrows-turn-to-dots',
    path: 'mapping/order-reference-pattern',
  };
  static readonly MAPPING_ORDER_REFERENCE_PATTERN: PageDescription = {
    label: 'page_title.mapping.order-reference-pattern',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/order-reference-pattern',
  };
  static readonly MAPPING_SOURCE: PageDescription = {
    label: 'page_title.mapping.source',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/source',
  };
  static readonly MAPPING_FEE: PageDescription = {
    label: 'page_title.mapping.fee',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/fee',
  };
  static readonly MAPPING_SRC_MAPPING_ACCOUNT_CODE: PageDescription = {
    label: 'page_title.mapping.src-mapping-account-code',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/account-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_EXCHANGE: PageDescription = {
    label: 'page_title.mapping.src-mapping-exchange',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/exchange-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_CONTRACT: PageDescription = {
    label: 'page_title.mapping.src-mapping-contract',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/contract-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_BROKER_CODE: PageDescription = {
    label: 'page_title.mapping.src-mapping-broker-code',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/broker-code-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_TRADER: PageDescription = {
    label: 'page_title.mapping.src-mapping-trader',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/trader-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_FEE: PageDescription = {
    label: 'page_title.mapping.src-mapping-fee',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/fee-mapping',
  };
  static readonly MAPPING_SRC_MAPPING_TRADE_TYPE: PageDescription = {
    label: 'page_title.mapping.src-mapping-trade-type',
    roles: CCRoles.ROLES_MAPPING_READ,
    path: 'mapping/trade-type-mapping',
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlMapping.MAPPING_ORDER_REFERENCE_PATTERN,
    CrystalClearFrontUrlMapping.MAPPING_SOURCE,
    CrystalClearFrontUrlMapping.MAPPING_FEE,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_ACCOUNT_CODE,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_EXCHANGE,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_CONTRACT,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_BROKER_CODE,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_TRADER,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_FEE,
    CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_TRADE_TYPE,
  ];
}

